'use strict';

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var helper = require('./myplaces_helper');
var placesStorage = require('./places_storage');

var myPlacesPromptCookieKey = 'my_places_prompt';

var MyPlaces = function () {
  function MyPlaces() {
    _classCallCheck(this, MyPlaces);
  }

  _createClass(MyPlaces, [{
    key: 'init',
    value: function init(typeahead, modal) {
      this.typeahead = typeahead;

      this.enabled = true; // we call init only if we enabled myplaces

      this.$location = $('#ls-location');
      this.$prompt = $('#my-places-prompt');

      this.bind(); // bind the events

      this.modal = modal;
    }
  }, {
    key: 'bind',
    value: function bind() {
      var $container = this.typeahead.$container;
      // $container.on('click', '.tw-heading .tw-act-sec', this.handleAddClick.bind(this));

      $container.on('click', '.tw-places-add a', this.handleAddClick.bind(this));
      $container.on('click', '.tw-places-item .tw-clear', this.handleRemoveClick.bind(this));
      $container.on('click', '.tw-places-more a', this.handleMoreClick.bind(this));
    }
  }, {
    key: 'needToBeCollapsed',
    value: function needToBeCollapsed() {
      return placesStorage.needToBeCollapsed();
    }
  }, {
    key: 'getPlaces',
    value: function getPlaces() {
      return placesStorage.items;
    }
  }, {
    key: 'rerenderTypeahead',
    value: function rerenderTypeahead() {
      // the typeahead might not be inited
      if (this.typeahead) {
        this.typeahead.showLocationWidget();
      }
    }

    // fetch my places after loaded user info

  }, {
    key: 'fetchMyPlaces',
    value: function fetchMyPlaces() {
      var signedIn = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : helper.isLoggedIn();

      if (!this.enabled) {
        return; // do not call API if we did not enabled myplaces
      }
      if (signedIn) {
        // fetch the data only if user has signed in
        this.loadMyPlaces(); // load my places from server
      } else {
        this.showPrompt(); // we still need to check if we need to show prompt
      }
    }

    // remove my place item

  }, {
    key: 'removeMyPlace',
    value: function removeMyPlace(id) {
      var _this = this;

      var items = placesStorage.items.slice(0);
      var $item = $('#place-' + id);
      placesStorage.update(items.filter(function (place) {
        return place.id !== id;
      })); // delete it from the local items
      $item.remove();

      // remove my place from server side
      helper.remove(id, {
        success: function success() /* res */{
          _this.rerenderTypeahead(); // refresh the autocomplete list
        },
        error: function error() /* err */{
          placesStorage.update(items); // rollback the results if failed to remove
          _this.rerenderTypeahead(); // refresh the autocomplete list
        }
      });
    }

    // add new place

  }, {
    key: 'handleAddClick',
    value: function handleAddClick(e) {
      e.preventDefault();
      e.stopImmediatePropagation();
      this.modal.open('', this.typeahead);
    }

    // remove a place item

  }, {
    key: 'handleRemoveClick',
    value: function handleRemoveClick(e) {
      e.preventDefault();
      e.stopImmediatePropagation();
      var $item = $(e.currentTarget).siblings('.tw-link');
      var placeId = $item.data('place-id');
      if (placeId) {
        this.removeMyPlace(placeId);
      }
    }

    // click "More Places" to show all the places

  }, {
    key: 'handleMoreClick',
    value: function handleMoreClick(e) {
      e.preventDefault();
      e.stopImmediatePropagation();
      placesStorage.showMore();
      this.rerenderTypeahead();
    }

    // verify if it's a valid address, not a city or zipcode

  }, {
    key: 'isAddress',
    value: function isAddress(location) {
      if (typeof location !== 'string') {
        return false;
      }
      return location.split(',').length > 2; // simple way to check
    }

    // check if this location had been saved to my places

  }, {
    key: 'hasNotSaved',
    value: function hasNotSaved(location) {
      return !placesStorage.contains(location);
    }

    // show prompt if we have the cookie

  }, {
    key: 'showPrompt',
    value: function showPrompt() {
      var _this2 = this;

      var address = helper.getCookie(myPlacesPromptCookieKey);
      if (this.isAddress(address) && this.hasNotSaved(address)) {
        this.$prompt.removeClass('ls-hide');
        var msg = 'Save this address: ' + address;
        $('#my-places-prompt-address').text(msg);

        $('#my-places-prompt-save').on('click', function (e) {
          e.preventDefault();
          e.stopImmediatePropagation();
          _this2.modal.open(address);
          _this2.$prompt.addClass('ls-hide');
        });
      }

      // only display once
      helper.removeCookie(myPlacesPromptCookieKey);
    }

    // set the prompt cookie if we change the location

  }, {
    key: 'setPromptCookie',
    value: function setPromptCookie(address) {
      if (this.isAddress(address) && this.hasNotSaved(address)) {
        helper.setCookie(myPlacesPromptCookieKey, address);
      }
    }

    // load my places from server side
    // if use has saved place before signed in
    //  save the place and load the latest places
    // else
    // just load the places

  }, {
    key: 'loadMyPlaces',
    value: function loadMyPlaces() {
      var _this3 = this;

      var place = helper.loadMyPlaceFromCookie();
      if (place) {
        helper.save(place, {
          success: function success() /* res */{
            helper.removeMyPlaceFromCookie(); // remove from cookie
            _this3.rerenderTypeahead();
            _this3.showPrompt();
          },
          error: function error() {
            // do nothing
            // keep the cookie, try to save it next time
          }
        });
      } else {
        helper.fetch({
          success: function success() /* res */{
            _this3.rerenderTypeahead();
            _this3.showPrompt();
          }
        });
      }
    }
  }]);

  return MyPlaces;
}();

module.exports = new MyPlaces();